import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { paginatorDeps } from '@ui/table/paginator/custom-mat-paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LimiterLength } from '@core/app/app.constants';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';


export type PaginatorParams = {
    length?: number;
    pageSize?: number;
    pageSizeOptions?: number[];
    pageIndex?: number;
};

@Component({
    selector: 'paginator',
    imports: [MatPaginatorModule, TranslatePipe],
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [paginatorDeps]
})
export class PaginatorComponent implements OnDestroy {
    @Input()
    public params: PaginatorParams;

    @Input()
    public set source(source: MatTableDataSource<unknown>) {
        if (source?.data && this.#matPaginator) {
            source.paginator = this.#matPaginator;

            this.params = {
                pageSizeOptions: [LimiterLength.PageItemsSize, 50, LimiterLength.PageItemsSize * 5],
                pageSize: LimiterLength.PageItemsSize,
                length: source?.data?.length || 0,
            };

            source.connect().pipe(takeUntil(this.#destroy$)).subscribe(() => this.params.length = source.data?.length);
        }
    }

    readonly #destroy$: Subject<unknown> = new Subject<unknown>();
    #matPaginator: MatPaginator;

    protected readonly limiterLength: typeof LimiterLength = LimiterLength;

    @ViewChild(MatPaginator, { static: true })
    public set matPaginator(matPaginator: MatPaginator) {
        this.#matPaginator = matPaginator;
    }

    @Output()
    public pagination: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

    public ngOnDestroy(): void {
        this.#destroy$.next(null);
        this.#destroy$.complete();
    }
}
